<template>
  <div>
    <div v-responsive.lg.xl class="pt-5">
             <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
             <section>
                <div class="mt-5 paralax-cover-image has-background-dim">
                    <div class="paralax-cover-image-text">
                    <div class="content_home" style="z-index: 1!important;">
                        <h1 style="text-align:left;font-size: 70px" class="font-weight-bold"><span style="color: #fff">{{ $t('assurances.assurances_vie.header_title[0]') }}</span></h1>
                        <h1 style="text-align:left;font-size: 70px;margin-top: -30px" class="font-weight-bold"><span style="color: #ffa409" class="ml-1">{{ $t('assurances.assurances_vie.header_title[1]') }}</span></h1>
                    </div>
                </div>
                </div>
            </section>
        </div>
        <div v-responsive.sm.xs class="pt-5">
             <!--PARITE HEADER AVEC IMAGES AVEC PARALAX DE L'IMAGE-->
             <section>
                <div class="paralax-cover-image_mobile has-background-dim_mobile">
                    <p class="paralax-cover-image-text_mobile">
                        <div class="content_home" style="z-index: 1!important;margin-top: 10%">
                            <h1 style="font-size: 40px" class="font-weight-bold"><span style="color: #fff">{{ $t('assurances.assurances_vie.header_title[0]') }}</span></h1>
                            <h1 style="font-size: 40px;margin-top: -20px;color: #ffa409" class="font-weight-bold"><span>{{ $t('assurances.assurances_vie.header_title[1]') }}</span></h1>
                        </div>
                    </p>
                </div>
            </section>
        </div>
    <!-- <Banner title="Assurance Vie" image-path="assurance/vie.jpg"></Banner> -->
    <div class="row containers">
        <div class="col-md-7 col-sm-12">
            <div class="grid-flex">
                <div class="col col-image-vie"></div>
                <div class="col col-text">
                    <div class="Aligner-item">
                        <p>&ldquo;{{ $t('assurances.assurances_vie.kiray_say_text') }}&rdquo;
                            <cite>- Kiray Assuraf</cite>
                        </p>
                    </div>
                </div>
            </div>
            <div class="justify-content-center row">
                <div class="pa-2 text-justify subheading font-weight-blod pl-md-5 pr-md-5" style="margin-bottom:-50px">
                    {{ $t('assurances.assurances_vie.texte_intro[0]') }}
                    <br>
                    {{ $t('assurances.assurances_vie.texte_intro[1]') }}

                    <div class="trigger_auto mt-3 mb-5">
                        <span> <a href="/devis/vie" style="text-decoration: none;color: #000000">{{ $t('assurances.assurances_vie.bouton_devis_gratuit') }}</a><i style="font-size: 20px" class="ml-4 fas fa-chevron-right "></i></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="divider mr-3 ml-3">
            <v-divider vertical></v-divider>
        </div>
        <div class="col-md-4 col-sm-12 mt-5">
            <DropdowAssurancePage>
                <template #label>
                    {{ $t('assurances.assurances_vie.first_question_title') }}
                </template>
                {{ $t('assurances.assurances_vie.first_question_content[0]') }}
            </DropdowAssurancePage>
            <DropdowAssurancePage>
                <template #label>
                    {{ $t('assurances.assurances_vie.second_question_title') }}
                </template>
                {{ $t('assurances.assurances_vie.second_question_content[0]') }}
            </DropdowAssurancePage>

            <DropdowAssurancePage>
                <template #label>
                    {{ $t('assurances.assurances_vie.third_question_title') }}
                </template>
                <span class="font-weight-bold" style="color:#ffa409">{{ $t('assurances.assurances_vie.third_question_content[0]') }}</span>{{ $t('assurances.assurances_vie.third_question_content[1]') }}
                <br><br>
                <p class="font-weight-bold" style="color: #ffa409;margin-bottom: 1%;margin-top: 1%;">{{ $t('assurances.assurances_vie.third_question_content[2]') }}</p>
                <span style="color: #ffa409">-</span> {{ $t('assurances.assurances_vie.third_question_content[3]') }}<br>
                <span style="color: #ffa409">-</span> {{ $t('assurances.assurances_vie.third_question_content[4]') }}

                <p class="font-weight-bold" style="color: #ffa409;margin-bottom: 1%;margin-top: 5%">{{ $t('assurances.assurances_vie.third_question_content[5]') }}
                    <br>{{ $t('assurances.assurances_vie.third_question_content[6]') }}</p>
                <span style="color: #ffa409">-</span> {{ $t('assurances.assurances_vie.third_question_content[7]') }} <br>
                <span style="color: #ffa409">-</span> {{ $t('assurances.assurances_vie.third_question_content[8]') }} <br>
                <span style="color: #ffa409">-</span> {{ $t('assurances.assurances_vie.third_question_content[9]') }}
                <p class="font-weight-bold" style="color: #ffa409;margin-bottom: 1%;margin-top: 5%">{{ $t('assurances.assurances_vie.third_question_content[10]') }}</p>
                {{ $t('assurances.assurances_vie.third_question_content[11]') }} <br>
                <span style="color: #ffa409">-</span> {{ $t('assurances.assurances_vie.third_question_content[12]') }} <br>
                <span style="color: #ffa409">-</span> {{ $t('assurances.assurances_vie.third_question_content[13]') }} <br>
                <span style="color: #ffa409">-</span> {{ $t('assurances.assurances_vie.third_question_content[14]') }}
            </DropdowAssurancePage>

            <DropdowAssurancePage activeBg>
                <template #label>
                    {{ $t('assurances.assurances_vie.four_question_title') }}
                </template>
                <ul style="list-style:none!important;" class="mr-2">
                    <li class="pb-2"><span class="font-weight-bold" style="color: #ffa409">- {{ $t('assurances.assurances_vie.four_question_content[0]') }} </span>{{ $t('assurances.assurances_vie.four_question_content[1]') }}</li>
                    <li class="pb-2"><span class="font-weight-bold" style="color: #ffa409">- {{ $t('assurances.assurances_vie.four_question_content[2]') }} </span>{{ $t('assurances.assurances_vie.four_question_content[3]') }}</li>
                    <li class="pb-2"><span class="font-weight-bold" style="color: #ffa409">- {{ $t('assurances.assurances_vie.four_question_content[4]') }} </span>{{ $t('assurances.assurances_vie.four_question_content[5]') }}</li>

                    <li class="pb-2"><span class="font-weight-bold" style="color: #ffa409">- {{ $t('assurances.assurances_vie.four_question_content[6]') }} </span>{{ $t('assurances.assurances_vie.four_question_content[7]') }}</li>
                    <li class="pb-2"><span class="font-weight-bold" style="color: #ffa409">- {{ $t('assurances.assurances_vie.four_question_content[8]') }} </span>{{ $t('assurances.assurances_vie.four_question_content[9]') }}</li>
                    <li class="pb-2"><span class="font-weight-bold" style="color: #ffa409">- {{ $t('assurances.assurances_vie.four_question_content[10]') }} </span>{{ $t('assurances.assurances_vie.four_question_content[11]') }}</li>

                    <li class="pb-2"><span class="font-weight-bold" style="color: #ffa409">- {{ $t('assurances.assurances_vie.four_question_content[12]') }} </span>{{ $t('assurances.assurances_vie.four_question_content[13]') }} <br>
                        <span class="ml-5 font-weight-bold" style="color: #ffa409">1</span> - {{ $t('assurances.assurances_vie.four_question_content[14]') }}
                        <br>
                        <span class="ml-5 font-weight-bold" style="color: #ffa409">2</span> - {{ $t('assurances.assurances_vie.four_question_content[15]') }}</li>
                    <li class="pb-2"><span class="font-weight-bold" style="color: #ffa409">- {{ $t('assurances.assurances_vie.four_question_content[16]') }} </span>{{ $t('assurances.assurances_vie.four_question_content[17]') }}</li>
                    <li class="pb-2"><span class="font-weight-bold" style="color: #ffa409">- {{ $t('assurances.assurances_vie.four_question_content[18]') }} </span>{{ $t('assurances.assurances_vie.four_question_content[19]') }}</li>
                    <li><span class="font-weight-bold" style="color: #ffa409">- {{ $t('assurances.assurances_vie.four_question_content[20]') }} </span>{{ $t('assurances.assurances_vie.four_question_content[21]') }}</li>
                </ul>
            </DropdowAssurancePage>
        </div>
    </div>
  </div>
</template>

<script>
import Banner from '../layouts/banners/banner.vue';
import DropdowAssurancePage from './DropdowAssurancePage.vue';

export default {
    name: 'DescriptionAssuranceVieComponent',
    components: {
        Banner,
        DropdowAssurancePage
    }
}
</script>

<style scoped>
.containers {
    padding: 20px 8%;
    /* display: flex; */
}
.trigger_auto{
    width: 270px;
}
.trigger_auto span {
    font-weight: bold;
    font-size: 16px;
    background: #ffa409;
    color: #000000;
    height: 50px;
    padding: 0 18px;
    cursor: pointer;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: center;
}
.grid-flex {
    margin-top: 5%;
}

@media only screen and (max-width: 767px) {
    .divider {
        display: none;
    }
}


.paralax-cover-image {
        background-image: url('../../assets/img/assurance/vie.jpg');
        position: relative;
        background-size: contain!important;
        background-position: 50%;
        min-height: 210px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
        /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
    }

    .paralax-cover-image .paralax-cover-image-text,
    .paralax-cover-image h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image.has-background-dim:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image {
        background-attachment: fixed;
        background-position: 50% 50px;
    }


  .paralax-cover-image_mobile {
        background-image: url('../../assets/img/assurance/vie_mobile.jpg');
        position: relative;
        background-size: contain;
        background-position: 50%;
        min-height: 150px;
        width: 100%;
        margin: 0 0 0;
        display: flex;
       /*padding: 20px;*/
        align-items: center;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;

    }
    .paralax-cover-image_mobile p {
        color: rgb(255, 255, 255);
        font-size: 20px;
        font-weight: 300;
        padding-bottom: 20Px;
    }

    .paralax-cover-image_mobile .paralax-cover-image-text_mobile,
    .paralax-cover-image_mobile h2 {
        color: #fff;
        font-size: 2em;
        line-height: 1.25;
        z-index: 1;
        margin-bottom: 0;
        max-width: 610px;
        text-align: center;
        margin-left: 8.5%;
    }

    .paralax-cover-image_mobile.has-background-dim_mobile:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .paralax-cover-image_mobile {
        /* background-attachment: fixed; */
        background-position: 100% 40px;
    }
</style>